import React, { Component, useState, useEffect, useRef } from 'react'
import Loader from '../Loader/Loader';
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import { Link } from 'react-router-dom';
import { APPLICATION_JSON } from '../../middleware/types';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { forgotPasswordMsgAction } from '../../middleware/forgotPasswordMsgAction';

export const CbLogin = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [redirectAccount, setRedirectAccount, redirectAccountRef] = useStateRef(false);
    const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef();
    const [guestLoginEnable, setGuestLoginEnable] = useState()
    const [urlParm, setUrlParm] = useState()
    const [searchParamUrl, setSearchParam, searchParamRef] = useStateRef("")
    const [restrictRemoveMsg, setRestrictRemoveMsg, restrictRemoveMsgRef] = useStateRef('')
    const history = useHistory();
    const dispatch = useDispatch();
    const location =useLocation();
    var locationState = location?.state;
    if(locationState && locationState?.successMsg){
       var forgotPasswordSuccessMessage = location.state?.successMsg;
    }else{
       var redirectUrlFromState = location.state;
    }
    //from reducer state
   // const successMessage = useSelector(state => state.forgotPasswordMsgReducer.message)
    const profile = useSelector(state => state.getProfileDetails.profileDetails)
    const [loginResponse, setLoginResponse, loginResponseRef] = useStateRef();
    const redirectUrl = useSelector(state => state.redirectUrlReducer)
    const [isZoomedOut, setIsZoomedOut] = useState(false);
    const errorDivRef = useRef(null);
    
    useEffect(()=>{
        console.log('redirectUrlFromState---',redirectUrlFromState)
        var pathUrl = location?.pathname
        const currentUrl = pathUrl?.split('?');
        const currentPath = currentUrl?.[0];
        var previous = location?.state?.previousUrl
        const previousUrl = previous?.split('?');
        const previousPath = previousUrl?.[0];
        // if previousUrl & current url is same redirect to home page
        if(previousPath == currentPath){
            console.log("pathUrl is equal to previous url",previousPath, currentPath)
            dispatch(redirectUrlAction("/"))
        } else {
            redirectUrlFromState && dispatch(redirectUrlAction(redirectUrlFromState?.previousUrl));
        }
    },[redirectUrlFromState])
    useEffect(() => {
        if (profile) {
            if (profile && profile.userType && urlParm && (urlParm == "account/login" || urlParm == "account/login.jsp")) {
                window.location.href = "/"
            }
        }
    }, [profile])

    useEffect(() => {
        var url = history.location.pathname
        var splitedUri = url.split("/")
        setGuestLoginEnable(splitedUri && splitedUri[1])
        {
            splitedUri && splitedUri[1] && splitedUri[2] ? setUrlParm(splitedUri[1] + "/" + splitedUri[2]) : "";
            if (urlParm) {
                console.log('urlParm...', urlParm);
            }
        }

        var searchParam = window.location.search

        if (searchParam && searchParam != null && searchParam != "") {
            var uri = searchParam.split("?")
            setSearchParam(searchParam.split("=") ? searchParam.split("=")[1] : "")
            if (uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
                if (uri[1].includes("sessionExpired=true")) {
                    if (document.getElementById("sessionExpired-error")) {
                        document.getElementById("sessionExpired-error").innerHTML = "Your session has timed out due to inactivity.Please login to continue";
                    }
                    if (document.getElementById("sessionExpired-error-div")) {
                        document.getElementById("sessionExpired-error-div").classList.remove("d-none");
                        document.getElementById("sessionExpired-error-div").classList.add("d-block");
                    }
                }
            } else if (uri && uri != null && uri.length > 0 && uri[1] == "DPSLogout=true") {
                if (document.getElementById("login-back")) {
                    document.getElementById("login-back").classList.remove("d-block")
                    document.getElementById("login-back").classList.add("d-none")
                    dispatch(redirectUrlAction("/account/landing"))
                }
            }
        }
        
        // }
        
    }, [urlParm])

    //here we change the profile details based on the response

    const goBack = (e) => {
        e.preventDefault()
        if (urlParm === "checkout/login" && e.ctrlKey || e.metakey) {
            window.open("/checkout/cart", "_blank")
        } else {
            if (urlParm === "checkout/login") {
                history.push("/checkout/cart")
            } else {
                console.log('history.go back called..');
                history.goBack();
            }
        }
    };

    const validateLoginForm = (key, value) => {
        switch (key) {
            case "username":
            	var validation = "^\\w+([\\.\\+'!#&*+/=?^_.{}~-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,})+$";
            	//CDP-5759 above Regex changed for username validation
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value.trim())
                if (result) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("login_userName").classList.add("form-error")
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "Email is a required field.";
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("login_userName").classList.add("form-error")
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "The email address does not appear to be valid. Please use the format name@domain.xxx.";
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else {
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "";
                }
                break;
            case "password":
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("login_password").classList.add("form-error")
                    var emptypassword = document.getElementById("password_error")
                    emptypassword.innerHTML = "Password is a required field.";
                    if (errorDivRef.current) {
                        errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else {
                    var emptypassword = document.getElementById("password_error")
                    emptypassword.innerHTML = "";
                }
                break;

            default:
        }
    }

    const clearErrorMsg = (e) => {
        setErrorMessage()
        document.getElementById("login-message-error").innerHTML = "";
        document.getElementById("login-message-error-div").classList.add("d-none");
        document.getElementById("login_userName").classList.remove("form-error")
        document.getElementById("login_password").classList.remove("form-error")

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        clearErrorMsg();
        setIsLoading(false)
        setHasError(false)
        if (document.getElementById("sessionExpired-error-div")) {
            document.getElementById("sessionExpired-error-div").classList.remove("d-block")
            document.getElementById("sessionExpired-error-div").classList.add("d-none")
        }
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateLoginForm(key, value)
        })
        var username = formData.get("username")
        var password = formData.get("password")
        const inputMap = {
            username: username,
            password: password
        }
        if (!setHasErrorRef.current) {

            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setRedirectAccount(true)
                        setIsLoading(false)
                        setIsZoomedOut(true);
                        const response = JSON.parse(res.response).response
                        if (response) {
                            localStorage.clear();
                            dispatch(updateProfileDetailsAction(true,"login"))
                            if (response.mergeOrderFlag == true) {
                                history.push("/checkout/cart")
                            } else if (searchParamRef.current && searchParamRef.current == 'list') {
                                history.push("/account/list?rp=y")
                            } else if (searchParamRef.current && searchParamRef.current == 'prev') {
                                if(redirectUrl && redirectUrl?.url === '/account/register'){
                                    history.push('/');
                                }else{
                                    history.goBack()
                                }
                            } else if (urlParm && urlParm == "checkout/login") {
                                response?.profileDetails?.userType == 2 && response?.profileDetails?.pricingMode ? history.push("/checkout/cart") : response?.profileDetails?.userType == 3 ? history.push("/checkout/int/save") : history.push("/checkout/shipping")
                            } else if (urlParm && urlParm == "account/login") {
                                history.push("/account/landing")
                            }
                        }
                        setLoginResponse(res)
                        username && window.heap.identify(username);
                    } else {
                        setIsLoading(false)
                        const error = JSON.parse(res._ERROR_MESSAGE_).message;
                        setErrorMessage(error);
                        document.getElementById("login-message-error-div").classList.remove("d-none");
                        document.getElementById("login-message-error-div").classList.add("d-block");
                        if (res.errorKey && res.errorKey === "email") {
                            document.getElementById("login_userName").classList.add("form-error")
                        } else {
                            document.getElementById("login_password").classList.add("form-error")
                        }
                        if (errorDivRef.current) {
                            errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }
                })
        }
    }

    async function restrictSuccess() {
        var actionUrl = "api/rest/cb/cart/qurantine-remove-message/true";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON)
        if (res.result == "success") {
            setRestrictRemoveMsg((JSON.parse(res?.response))?.response?.quarantineRemoveMsg)
        }
    }
    useEffect(() => {
        var searchParamQuery = window.location.search
        if (searchParamQuery === '?qr=true') {
            restrictSuccess()
        }
        if (forgotPasswordSuccessMessage && forgotPasswordSuccessMessage !='' && forgotPasswordSuccessMessage != null) {
            document.getElementById("forgot-success").classList.remove("d-none")
            document.getElementById("forgot-success").classList.add("d-block")
            document.getElementById("login-back").classList.remove("d-block")
            document.getElementById("login-back").classList.add("d-none")
        }
    }, [])
    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail ${isZoomedOut ? 'cb-login-zoom-out' : ''}`} >
            {profile && profile.transient ?
                <>
                    <div className={`col-12 px-4 ${errorMessageRef.current ? 'mt-md-4 mt-3': ''}`}>
                        <div id="sessionExpired-error-div" className="d-none alert alert-danger login-error-msg">
                            <div id="sessionExpired-error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div>
                        </div>
                    </div>
                    <div className='row justify-content-center gx-0'>
                        <div className={`col-12 col-md-8 mx-auto mt-md-4 mt-3 ${restrictRemoveMsgRef.current && 'px-4'}`}>
                            {restrictRemoveMsgRef.current &&
                                <div className="alert alert-warning d-block">
                                    <p className="black-color">
                                        {restrictRemoveMsgRef.current}
                                    </p>
                                </div>}
                            <div id="login-message-success-div" className="d-none alert alert-success mx-2">
                                <div id="login-message-success"></div>
                            </div>

                            <div id="forgot-success" className="alert alert-warning mb-3 mx-2 d-none" >
                                <p className="black-color" dangerouslySetInnerHTML={{ __html:forgotPasswordSuccessMessage }}></p>
                            </div>


                            <div id="login-message-error-div" ref={errorDivRef} className="d-none alert alert-danger login-error-msg mx-2 form-error-messages">

                                {/* <div id="login-message-error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div> */}
                                <div id="login-message-error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div>

                                <div id="username_error-page"></div>
                                <div id="password_error"></div>
                            </div>

                        </div>

                    </div>
                    <div className='row justify-content-center gx-0'>
                        <div className="col-12 row col-md-4 mb-md-5 mx-auto mt-3 mt-md-0">
                            
                                {isLoading ? <Loader /> : ""}
                                <div id="login-back" className="text-left mb-2 c-back-link text-left px-0" onClick={goBack} style={{ cursor: 'pointer' }}>&lt; {urlParm === "checkout/login" ? "back to cart" : "back to previous page"}</div>

                                <div className="c-account-wrapper">
                                    <div className="text-left mt-3 mb-3">
                                        <h1 className="c-account-heading">
                                            {guestLoginEnable && guestLoginEnable == "checkout" ? "Sign in to Continue" :
                                                "Sign in to Your Account"}
                                        </h1>
                                    </div>
                                    <form autoComplete='off' method="post" action="login" id="customLogin" className="row g-3 c-account-page" onSubmit={handleSubmit} noValidate>
                                        <div className="col-md-12">
                                            <label for="inputEmail4" className="form-label">Email</label>
                                            <input  maxlength="256" name="username" id="login_userName" type="email" className="form-control" />
                                        </div>
                                        <div className="col-md-12 c-show-password" style={{ position: 'relative' }}>
                                            <label for="inputPassword" className="form-label">Password</label>
                                            <input name="password" id="login_password" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)} />
                                            <p className="c-login-show hyperLinkStyle" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                                {isRevealPwd ? 'HIDE' : 'SHOW'}
                                            </p>
                                        </div>
                                        <div className="col-12 d-grid">
                                            <button type="submit" className="btn btn-primary block" id="signin-button">Sign In</button>
                                        </div>
                                    </form>
                                    <div className="col-12 ml-auto mt-4 mb-4">
                                        <Link className="c-back-link text-left" 
                                        to={`${searchParamRef.current && searchParamRef.current == 'prev' ? '/account/forgotPassword?resume=prev' : searchParamRef.current && searchParamRef.current == 'list' ? '/account/forgotPassword?resume=list' :
                                        urlParm && urlParm == 'checkout/login' ? '/checkout/forgotPassword' : '/account/forgotPassword'}`} >
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <hr />
                                    <div className="text-left d-lg-block d-md-none d-none mt-2">
                                        <p className="text-left c-regular-text m-hidden">New to Carolina.com?</p>
                                    </div>
                                    <Link to={`${urlParm && urlParm == 'checkout/login' ? '/checkout/register' : '/account/register'}`}
                                    className="register-link col-12 d-grid mt-0 mb-3" style={{ textDecoration: "none" }}>
                                        <button type="submit" className="btn btn-secondary block">Register New Account</button>
                                    </Link>
                                    {guestLoginEnable && guestLoginEnable == "checkout" ?
                                    <div className='guestLink guestLinkPosition'>
                                        
                                        <div className="blue-text blue-link font-weight-bold text-center  ">
                                            <Link className="underline brightBlue font-size-13" to="/checkout/shipping">
                                                Continue as Guest
                                            </Link>
                                        </div>
                                        {containerObject?.attributes?.webMessage? <div dangerouslySetInnerHTML={{ __html: containerObject?.attributes?.webMessage }}></div>:""}
                                        </div> : ""}
                                </div>
                                {guestLoginEnable && guestLoginEnable == "checkout" ?
                                    <div className="c-shipping-guest">
                                        <i className="bi bi-lock-fill"></i>
                                        <span>
                                            Secure Checkout Shopping is always safe and secure
                                        </span>
                                    </div>
                                    : ""}
                            
                        </div></div>
                </> : ""
            }
        </div>
    </>
    )
}
